export default {
    "GPSMAP": {
        "DEVICE": "Device",
        "ALL_DEVICES": "All devices",
        "USER": "User",
        "ALL_USERS": "All users",
        "FROM": "From",
        "TO": "To",
        "HEATMAP": "Heatmap",
        "HEAT_RADIUS": "Heat radius",
        "PATHS": "Connect path per device",
        "LOAD": "Load data",
        "CLEAR": "Clear",
    }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/en/gpsmap.js